import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'commandtypes',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `commandtypes`,
    method: 'get',
    params: queriesParams
  })
}

export function show (id) {
  return request({
    url: `commandtype/${id}`,
    method: 'get'
  })
}

export function add (data) {
  return request({
    url: 'commandtype',
    method: 'post',
    data
  })
}

export function edit (id, data) {
  return request({
    url: `commandtype/${id}`,
    method: 'patch',
    data
  })
}